import lazyRetry from 'lib/lazyRetry';
import React, { lazy } from 'react';
import { Route } from 'react-router-dom';

const ResidenceListPage = lazy(() => lazyRetry(() => import('./ListPage/ResidenceListPage')));

export const routes = [<Route key="1" exact path="/properties" component={ResidenceListPage} />];

export const navigation = [{ name: 'Residence', link: '/Residence' }];
